module.exports = __webpack_public_path__ + "img/tel.ab0228e0.png";